import React from 'react'
import moment from 'moment'
import { NavLink } from 'react-router-dom'

import Deals from '../../images/deals.svg'
import Payout from '../../images/payout.svg'
// import Ratings from '../../images/ratings.svg'
// import Bookings from '../../images/bookings.svg'
// import Amenities from '../../images/amenities.svg'
import Dashboard from '../../images/dashboard.svg'
import CancellationIcon from '../../images/free-cancellation-icon.svg'
import RatingsIcon from '../../images/total-reviews.svg'
import InventoryViewIcon from '../../images/inventoryView.svg'
import { routePrefix } from '../../config'
import { opdbGTM } from '../../utils/pulseUtils'

const arr = ['/buspanel', '/buspanel/', '/']

const styles = {
  tempCircle: {
    height: 70,
    width: 70,
    marginBottom: 20,
    backgroundColor: '#2b3b6f',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white'
  },
  date: { fontSize: 10, opacity: 0.99, color: '#999999' },
  tabName: { color: '#4a4a4a' }
}

function checkActiveTab(tabName, link) {
  if(link === '/' && arr.includes(window.location.pathname)) return true;
  if(link !== '/' && window.location.pathname.includes(link)) return true;
  return false;
}

export default class LeftPanel extends React.Component {

  constructor() {
    super();
    this.date = new moment().format('LL dddd')
  }

  render() {
    const { operator_name = 'User' } = this.props.allRoutesInfo;
    let via_route_support = JSON.parse(localStorage.getItem('via-routes-support'));
    return (
      <div className="col-xs-2" style={{ flexDirection: 'column', height: 'calc(100vh - 68px)', overflow: 'scroll', borderRight: '1px solid #E6EBF3'}}>
        <div className="operator-details">
          {this.props.operatorDetails.operator_logo ?
              <img src={this.props.operatorDetails.operator_logo} alt="operator-logo" />
            :
            <div style={styles.tempCircle}>{operator_name[0]}</div>
          }
          <p>{operator_name}</p>
          {/*<p>tours and travels</p>*/}
          <p style={styles.date}>{this.date}</p>
          <p style={styles.date}>Provider Id: {this.props.allRoutesInfo.provider_id}</p>
          <p style={styles.date}>Operator Id: {this.props.allRoutesInfo.operator_id}</p>
        </div>
        {(this.props.operatorInfo.isKsrtc || this.props.operatorInfo.isApsrtc) ? <div style={{ paddingTop: 20 }}>
        <TabSection link="/" alt="Dashboard" imgSrc={Dashboard} tabName="Dashboard"/>
        {this.props.operatorInfo.isApsrtc && <TabSection link="/inventory-view" alt="Inventory View" imgSrc={InventoryViewIcon} tabName="Inventory View" />}
        <TabSection link="/user-management" alt="User-Management" imgSrc={Payout} tabName="User Management" />
        <TabSection link="/bus-service-info" alt="Bus Photos" imgSrc={Deals} tabName="Bus Photos" />
        </div> : <div style={{ paddingTop: 20 }}>
          <TabSection link="/" alt="Dashboard" imgSrc={Dashboard} tabName="Dashboard"/>
          <TabSection link="/payout" alt="Payout" imgSrc={Payout} tabName="Payout" />
          <TabSection link="/deals" alt="Deals" imgSrc={Deals} tabName="Deals" />
          <TabSection link="/ratings-reviews" alt="Ratings Reviews" imgSrc={RatingsIcon} tabName="Ratings Reviews" />
          <TabSection link="/inventory-refresh" alt="Inventory Refresh" imgSrc={Deals} tabName="Inventory Refresh" />
          {via_route_support && <TabSection link="/inventory-view" alt="Inventory View" imgSrc={InventoryViewIcon} tabName="Inventory View" />}
          <TabSection link="/bus-service-info" alt="Bus Photos" imgSrc={Deals} tabName="Bus Photos" />
          <TabSection link="/restStop-configuration" alt="Rest stops Configuration" imgSrc={CancellationIcon} tabName="Rest stops Configuration" />
          <TabSection link="/user-management" alt="User-Management" imgSrc={Payout} tabName="User Management" />
          <TabSection link="/driver-details" alt="Driver-Details" imgSrc={Deals} tabName="Driver Details" />
          {/* <TabSection link="/cancellation-offer" alt="Free Cancellation" imgSrc={CancellationIcon} tabName="Free Cancellation" /> */}
        </div>}
      </div>
    )
  }
}

// className={`tabSection ${isActive? "activeTab": ""}`}
const TabSection = ({ imgSrc, tabName, isActive, link, alt='' }) => (
  <NavLink to={routePrefix + link} activeClassName="activeTab">
    <p className={`tabSection ${checkActiveTab(tabName, link)? "activeTab": ""}`}>
      <img alt={alt} style={{ verticalAlign: 'middle', marginRight: 20, paddingLeft: 20 }} src={imgSrc} />
      <span>{tabName}</span>
    </p>
  </NavLink>
)
